"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgPublicTransit = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M303.2 573.6c-32.7 0-59.3 26.6-59.3 59.3s26.6 59.4 59.3 59.4 59.4-26.6 59.4-59.4c0-32.7-26.7-59.3-59.4-59.3m417.6 0c-32.7 0-59.3 26.6-59.3 59.3s26.6 59.4 59.3 59.4 59.3-26.6 59.3-59.4c0-32.7-26.6-59.3-59.3-59.3M910.7 959 803.2 848.7c28.9-5.2 55.5-19 76.5-39.9 27-26.8 41.8-62.1 41.8-99.7V139.6c-.6-37.4-16-72.5-43.3-98.8S814.9 0 776.7 0H244.9c-38.1.6-73.8 15.6-100.7 42.3-27 26.8-41.8 62.1-41.8 99.6v569.5c.6 37.4 16 72.5 43.4 98.8 20.9 20.1 46.8 33.3 75 38.4L113.2 959.1l-.4.4c-7 7.4-10.7 17.1-10.4 27.3s4.6 19.7 12.2 26.7c7.3 6.8 16.8 10.5 26.8 10.5 10.6 0 20.9-4.3 28.1-11.9l157-161.1h371l157 161.2.4.4c7.3 7.3 17.2 11.4 27.7 11.4 10 0 19.5-3.7 26.8-10.5 7.6-7.1 11.9-16.7 12.2-27 .2-10.3-3.7-20.1-10.9-27.5M178.1 128.8c5.1-30 32.6-53 65.2-53h523.8c32.8 0 60.1 23 65.2 53zm374.7 202.9V201.6h294v130.1zm-375.6 0V201.6h294v130.1zm589.9 447.8h-525c-35.8-.6-65-29.6-65-64.7V422.1h656V716c-.6 35-30.2 63.5-66 63.5" })));
const ForwardRef = (0, react_1.forwardRef)(SvgPublicTransit);
exports.default = ForwardRef;
